import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["mouseTrail", "targetWidth", "targetHeight", "align", "children", "style"];
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useState, useRef, useEffect } from 'react';
import Tooltip from 'antd/lib/tooltip';
var CustomTooltip = props => {
  var mouseTrail = props.mouseTrail,
    targetWidth = props.targetWidth,
    targetHeight = props.targetHeight,
    align = props.align,
    children = props.children,
    style = props.style,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    x = _useState2[0],
    setX = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    y = _useState4[0],
    setY = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    alignment = _useState6[0],
    setAlignment = _useState6[1];
  var containerRef = useRef(null);
  var getMouseMotion = e => {
    e.preventDefault();
    setX(e.clientX);
    setY(e.clientY);
  };
  var tooltipSizeRef = useRef([]);
  useEffect(() => {
    if (containerRef.current && mouseTrail) {
      var _tooltipSizeRef$curre;
      var _containerRef$current = containerRef.current.getBoundingClientRect(),
        left = _containerRef$current.left,
        top = _containerRef$current.top;
      if (!((_tooltipSizeRef$curre = tooltipSizeRef.current) !== null && _tooltipSizeRef$curre !== void 0 && _tooltipSizeRef$curre.length)) {
        var _tooltip$clientWidth, _tooltip$clientHeight;
        var tooltip = document.querySelector('.sk-tooltip');
        var _width = (_tooltip$clientWidth = tooltip === null || tooltip === void 0 ? void 0 : tooltip.clientWidth) !== null && _tooltip$clientWidth !== void 0 ? _tooltip$clientWidth : 0;
        var _height = (_tooltip$clientHeight = tooltip === null || tooltip === void 0 ? void 0 : tooltip.clientHeight) !== null && _tooltip$clientHeight !== void 0 ? _tooltip$clientHeight : 0;
        if (_width && _height) {
          tooltipSizeRef.current = [_width, _height];
        }
      }
      var offsetLeft = x - left + 8;
      var offsetTop = y - top + 10;
      var _tooltipSizeRef$curre2 = _slicedToArray(tooltipSizeRef.current, 2),
        width = _tooltipSizeRef$curre2[0],
        height = _tooltipSizeRef$curre2[1];
      var outOfWidth = !!width && window.innerWidth - x - 8 < width;
      var outOfHeight = !!height && window.innerHeight - y - 10 < height;
      setAlignment({
        points: [`${outOfHeight ? 'b' : 't'}${outOfWidth ? 'r' : 'l'}`, `${outOfHeight ? 'b' : 't'}${outOfWidth ? 'r' : 'l'}`],
        offset: [outOfWidth ? -16 : offsetLeft, outOfHeight ? -16 : offsetTop],
        useCssTransform: false
      });
    }
  }, [mouseTrail, x, y]);
  return mouseTrail ? /*#__PURE__*/React.createElement(Tooltip, _extends({
    align: alignment,
    destroyTooltipOnHide: {
      keepParent: false
    },
    overlayClassName: "sk-tooltip"
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({
      width: targetWidth,
      height: targetHeight
    }, style !== null && style !== void 0 ? style : {}),
    onMouseMove: getMouseMotion,
    ref: containerRef
  }, children)) : /*#__PURE__*/React.createElement(Tooltip, _extends({
    align: align
  }, otherProps), children);
};
export default CustomTooltip;